import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const Base = types.model({
  id: types.maybeNull(types.string),
  creationTime: types.maybeNull(types.string),
  creatorId: types.maybeNull(types.string),
  lastModificationTime: types.maybeNull(types.string),
  lastModifierId: types.maybeNull(types.string),
  isDeleted: types.maybeNull(types.boolean),
  deleterId: types.maybeNull(types.string),
  deletionTime: types.maybeNull(types.string),
  tenantId: types.maybeNull(types.string),
});
export interface IBase extends Instance<typeof Base> {}
export interface IBaseProperties extends SnapshotIn<typeof Base> {}

export const Catalogue = types
  .model({
    code: types.string,
    name: types.string,
    id: types.string,
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    toOptionItem: (): OptionItem => {
      return {
        value: self.id,
        label: self.name,
      };
    },
  }));
export interface ICatalogue extends Instance<typeof Catalogue> {}
export interface ICatalogueProperties extends SnapshotIn<typeof Catalogue> {}
